module.exports = __webpack_public_path__ + "static/media/video-perisur.391b0ad1.jpg";